define('modules/editor/collections/page_scripts',['require','exports','module','backbone'],function(require, exports, module) {
  "use strict";
  var Backbone = require("backbone");

  var CORREO_DIRECT = "Correo Direct";
  /* This "element" is particular because it's related directly
  with the overall Page model. It has no visual representation but
  should be included in the serialization in order to use these CSS
  styles in Preview and Published states */
  var ScriptElement =  Backbone.Model.extend({
    defaults: {
      name: "",
      content: "",
      isTag: false,
      head: false
    }
  });

  module.exports = Backbone.Collection.extend({
    model: ScriptElement,
    addItem: function(){
      var newItem = new ScriptElement({
        name: "Script " + (this.length+1)
      });
      this.add(newItem);
      return newItem;
    },
    showHelp: function(e){
       var $this = $(e.target).parent();
       var url = $this.find('#scriptsURLHelp').text();
       $this.attr('href', url);
    },
    toggleCorreoDirectScripts: function(idaf, value) {
      value = value !== undefined ? value : !this.findWhere({ name: CORREO_DIRECT });
      return value ? this.addCorreoDirectScripts(idaf) : this.removeCorreoDirectScripts();
    },
    addCorreoDirectScripts: function(idaf) {
      if (!this.findWhere({ name: CORREO_DIRECT })) {
        this.add({
          name: CORREO_DIRECT,
          isTag: true,
          head: false,
          content: '<script src="//clients.landings.mdirector.com/correodirect/sponsors_load.js"></script>'
        });
      }
    },
    removeCorreoDirectScripts: function() {
      this.remove(this.findWhere({ name: CORREO_DIRECT }));
    }
  },
  {
    fromJSON: function(json){
      return new module.exports(json);
    }
  });
});

